import { BuyCreditsModal } from "@/components/credits/BuyCreditsModal";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import z from "zod";

const historyStateSchema = z
  .object({
    neededCredits: z.number(),
  })
  .optional()
  .catch(undefined);

const parseHistoryState = (historyState: z.infer<typeof historyStateSchema>) =>
  historyStateSchema.parse(historyState);

export const Route = createFileRoute(
  "/_dashboard/campaigns/$id/(edit)/start-campaign/buy-credits",
)({
  staticData: {
    crumb: "Tilkøb credits",
    meta: {
      title: "Tilkøb credits",
    },
  },
  beforeLoad: ({ context, location }) => {
    const historyState = parseHistoryState(
      location.state.routeStates?.[Route.id],
    );

    if (!historyState) throw redirect({ to: ".." });

    return {
      parseHistoryState,
      useStartCampaignHistoryState: context.useHistoryState,
      useHistoryState: () => historyState,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const context = Route.useRouteContext();

  const historyState = context.useHistoryState();
  const startCampaignHistoryState = context.useStartCampaignHistoryState();

  const navigate = useNavigate();

  const goBack = async (shouldContinue: boolean) => {
    if (shouldContinue) {
      await navigate({
        from: Route.fullPath,
        to: "..",
        search: {
          skipCreditCheck: true,
        },
        state: true,
      });
    } else {
      await navigate(startCampaignHistoryState.returnTo);
    }
  };

  return (
    <div className="flex flex-col">
      <BuyCreditsModal
        neededCredits={historyState.neededCredits}
        onClose={() => goBack(false)}
        onSuccess={() => goBack(true)}
        onSkip={() => goBack(true)}
      />
    </div>
  );
}
